import React from 'react';
import { Col } from 'antd';
import PlaceholderResolutionsCard from './PlaceholderResolutionsCard';

const PlaceholderSlider = ({
  listResolution,
  fetchingPlaceholders,
  placeholders
}) => (
  <Col xs={24} sm={24} md={24} lg={24}>
    <div className="resolution-grid">
      {listResolution &&
        listResolution.map((relation, index) => (
          <div key={index} style={{ position: 'relative' }}>
            <PlaceholderResolutionsCard
              relation={relation}
              loading={fetchingPlaceholders}
              placeholder={
                placeholders
                  ? placeholders.find(
                      ph =>
                        ph.width === relation.resolution_width &&
                        ph.height === relation.resolution_height
                    )
                  : null
              }
            />
          </div>
        ))}
    </div>
  </Col>
);

export default PlaceholderSlider;
